// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import { Link } from '../../internal/Button';
import LazyLoadImage from '../../internal/LazyLoadImage';
import img from '../../static/images/esg.png';

type CtaLink = {|
  text: string,
  href: string,
|};

type BackgroundColors = 'White' | 'Silver' | 'Charcoal' | 'Green' | 'Black';

type PropTypes = {|
  background?: BackgroundColors,
  text?: string,
  ctaLinks: Array<CtaLink>,
  theme?: 'Light' | 'Dark',
|};

const findBestTheme = (background?: BackgroundColors) => {
  switch (background) {
    case 'Green':
      return 'Dark';
    case 'Charcoal':
    case 'Black':
      return 'Light';
    default: {
      return 'Dark';
    }
  }
};

const ESGCta = ({
  background = 'Silver',
  text,
  theme = findBestTheme(background),
  ctaLinks,
}: PropTypes) => (
  <div
    className={cx(
      styles.block,
      background === 'Black' && styles.black,
      background === 'Silver' && styles.silver,
      background === 'Green' && styles.green,
      background === 'Charcoal' && styles.charcoal,
      background === 'White' && styles.white,
    )}
    // style={{
    //   backgroundImage: `url(${img})`,
    // }}
  >
    <div
      style={{
        flex: 1,
      }}
    >
      <h4 className={cx(styles.titleText)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1161.72 303.93"
          fill={theme === 'Light' ? '#fff' : '#221f20'}
          className={styles.titleImage}
        >
          <path d="M153.37,4.64c77.92,0,141.08,63.27,141.08,141.33H153.37Z" />
          <path d="M153.37,158.26H294.45V299.58H224.58a71.26,71.26,0,0,1-71.21-71.33h0Z" />
          <ellipse cx="70.55" cy="75.3" rx="70.54" ry="70.66" />
          <path d="M0,228.92a70.59,70.59,0,0,1,70.53-70.66H141.1v70.66A70.55,70.55,0,1,1,0,230.6Q0,229.76,0,228.92Z" />
          <path d="M413,4.14H619.39V31.76H442.49V133.82H594v27.42H442.49V272.37H623.72v27.42H413Z" />
          <path d="M678.91,206.81c0,44.33,34.23,69.69,84.12,69.69h4.12c44.33,0,69.69-23.92,69.69-54.85,0-27.21-17.52-43.09-54.84-50.72l-47.21-9.69q-70.51-14.53-70.52-76.69C663.45,38,704.48-.81,765.51,0,828-.61,869.62,35.68,871.07,90.73H841.58c-2.47-38.35-33-63.3-74-63.3h-4.13c-40.61,0-69.68,24.54-69.68,56.5,0,25.77,17.93,41.44,49.07,47.83L790,141q76.4,15.15,76.49,79c.62,51.55-40.61,84.33-103.09,83.92-71.75,0-114-35.88-114-97.11Z" />
          <path d="M1042.13,0c66.81-.41,111.55,40.21,117.52,99.17H1130c-6.6-44.94-38.77-71.75-85.57-71.75h-4.33c-62.26-.61-107,46-106.38,124.54-.42,78.75,44.12,125.14,107.62,124.53h4.33c46.39.61,89.48-31.14,88.66-81.86V179.39h-90.93V152h90.93c18.34,0,27.42,9.07,27.42,27.42v120.4H1134.3V261.45c-9.28,13.19-21.86,23.5-38.15,31.13s-34.43,11.34-54.43,11.34C957,305,903.58,240.42,904.2,152,903.38,63.52,956.36-1,1042.13,0Z" />
        </svg>

        <span className={cx(styles.visuallyhidden)}>ESG</span>
      </h4>

      {text && (
        <p
          className={cx(
            styles.blockText,
            theme === 'Light' && styles.whiteText,
            theme === 'Dark' && styles.blackText,
          )}
        >
          {text}
        </p>
      )}

      {ctaLinks.length > 0 && (
        <div className={styles.links}>
          {ctaLinks.map(ctaLink => (
            <Link href={ctaLink.href} variant={theme === 'Light' ? 'WhiteLink' : 'BlackLink'}>
              {ctaLink.text}
            </Link>
          ))}
        </div>
      )}
    </div>
    <div>
      <LazyLoadImage
        src={img}
        alt=""
        className={styles.image}
        defaultSize={{ width: 714, height: 216 }}
      />
    </div>
  </div>
);

export default ESGCta;
